<template>
    <ion-page>
        <ion-header>
            <ion-toolbar>
                <ion-title>Login</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content :fullscreen="true">
            <ion-header collapse="condense">
                <ion-toolbar>
                    <ion-title size="large">Login</ion-title>
                </ion-toolbar>
            </ion-header>
            <ion-card class="ion-margin-top">
                <ion-card-header>
                    <ion-card-title>Accedi</ion-card-title>
                    <ion-card-subtitle>Utilizza le tue credenziali per accedere al servizio</ion-card-subtitle>
                </ion-card-header>

                <ion-card-content>
                    <form>
                        <ion-list>
                            <ion-item style="--padding-start: 0">
                                <ion-input
                                    ref="usernameField"
                                    label="Username"
                                    label-placement="floating"
                                    class="ion-touched"
                                    :class="{ 'ion-invalid': usernameFeedback !== '' }"
                                    v-model="username"
                                    :error-text="usernameFeedback"
                                    placeholder="username"></ion-input>
                            </ion-item>
                            <ion-item style="--padding-start: 0">
                                <ion-input
                                    ref="passwordField"
                                    label="Password"
                                    label-placement="floating"
                                    class="ion-touched"
                                    :class="{ 'ion-invalid': passwordFeedback !== '' }"
                                    type="password"
                                    :error-text="passwordFeedback"
                                    v-model="password"
                                    placeholder="password"></ion-input>
                            </ion-item>
                        </ion-list>
                        <ion-button @click="performLogin" class="ion-margin-top" expand="block">
                            <span v-if="!isAuthLoading">Accedi</span>
                            <ion-spinner v-else>Accedi</ion-spinner>
                        </ion-button>
                    </form>
                </ion-card-content>
            </ion-card>
        </ion-content>
    </ion-page>
</template>

<script setup lang="ts">
import {
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonCard,
    IonCardHeader,
    IonCardTitle,
    IonCardSubtitle,
    IonCardContent,
    IonList,
    IonItem,
    IonInput,
    IonSpinner,
    IonButton,
    toastController,
} from "@ionic/vue";
import { useAuthStore } from "@/stores/auth";
import { computed, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { useCostumersStore } from "@/stores/costumers";

const router = useRouter();
const authStore = useAuthStore();
const nonFieldErrors = reactive<string[]>([]);
const username = ref<string>("");
const usernameField = ref<HTMLElement | null>(null);
const usernameFeedback = ref<string>("");
const password = ref<string>("");
const passwordField = ref<HTMLElement | null>(null);
const passwordFeedback = ref<string>("");
const isAuthLoading = computed(() => authStore.isAuthenticationLoading);

const presentToast = async (message: string) =>
    toastController
        .create({
            message: message,
            duration: 1500,
            position: "top",
            color: "danger",
        })
        .then((toast) => toast.present());
const performLogin = async () => {
    nonFieldErrors.length = 0;
    usernameFeedback.value = "";
    passwordFeedback.value = "";
    const response = await authStore.login(username.value, password.value);
    if (response.status !== 200) {
        if (response.data.non_field_errors) {
            presentToast(response.data.non_field_errors.join(" "));
        }
        if (response.data.username) {
            usernameFeedback.value = response.data.username.join(" ");
        }
        if (response.data.password) {
            passwordFeedback.value = response.data.password.join(" ");
        }
    } else {
        router.push({ name: "home" });
    }
};

defineExpose({ usernameField, passwordField });
</script>

<style scoped></style>
